import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#00923F",
    },
    secondary: {
      main: "#E77514",
    },
  },
});

export default theme;
